import type { FieldProps } from "@/types/form-types"
import FieldInfoIcon from "../../components/field-info"
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "../../components/ui/form"
import { cn } from "../../lib/utils"
import { Description } from "./components/description"
import { FileField } from "./file-upload"
import { useFormStore } from "@/stores/use-form-store"
import { useLogicStore } from "@/stores/use-conditional-logic-store"
import { ErrorMessage } from "./components/error-message"

export const FileUploadField = ({
	form,
	field,
	commonAttributes,
}: FieldProps) => {
	const { label, infoIconText, infoIconType, description, infoIconRequired } =
		commonAttributes
	const { shouldDisable, verifiedFields } = useFormStore()

	const isVerified = verifiedFields.get(field.field_id) || false
	const { hiddenFields, errors } = useLogicStore()

	if (hiddenFields[field.field_id]) return null

	return (
		<FormField
			name={field.field_id}
			control={form.control}
			render={({ field: formField }) => (
				<FormItem>
					<FormLabel>
						<div className="flex flex-col gap-1">
							<div className="flex items-center gap-1">
								<p
									className={cn(
										field.is_required &&
											"after:ml-1 after:text-red-500 after:content-['*']",
									)}
								>
									{label}
								</p>
								{infoIconRequired && (
									<FieldInfoIcon
										infoText={infoIconText}
										iconType={infoIconType}
									/>
								)}
							</div>
							{description && (
								<Description description={description} />
							)}
						</div>
					</FormLabel>
					<FormControl>
						<FileField
							shouldDisable={isVerified || shouldDisable}
							config={field}
							value={
								formField.value && formField.value !== ""
									? formField.value
									: []
							}
							onChange={formField.onChange}
							error={
								form.formState.errors[field.field_id]
									?.message as string
							}
						/>
					</FormControl>
					<FormMessage />
					<ErrorMessage error={errors[field.field_id]} />
				</FormItem>
			)}
		/>
	)
}
